import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"
import * as React from 'react'

export default { BLOCKS, MARKS, renderRichText, React }